export const environment = {
  production: false,
  apiBaseUrl: 'https://bff-currencyexchange.dev.grupomadero.com.br',
  loginPath: '/Login',
  currencyExchangePath: '/api/v1/Quotation',
  pollIntervalMs: 60_000,
  useCurrencyExchangeMock: false,
  CRYPTO_AES_KEY: '4So+kfod/O+SJ1Gika2X6osyntrKNAL1//sFS0U2Tlk=',
  CRYPTO_AES_IV: '3AB5lsqxDsfUBImCf3pN3w==',
};
